import Swiper, { Autoplay, Navigation } from "swiper";

export const initContentGallerySlider = () => {
    const gallerySlices = document.querySelectorAll('.cms-content-gallery-slice');

    gallerySlices.forEach((el) => {
        const mainSwiper = initializeMainSlider(el);
        const labelSliderContainer = el.querySelector('.cms-content-gallery-slice__label-slider');
        
        if (mainSwiper && labelSliderContainer) {
            initializeLabelSlider(labelSliderContainer, mainSwiper);
        }
    });
};

function initializeMainSlider(el) {
    const slider = el.querySelector('.cms-content-gallery-slice__main-swiper');
    return new Swiper(slider, {
        modules: [Autoplay, Navigation],
        speed: 100,
        loop: false,
        navigation: {
            nextEl: el.querySelector('.cms-content-gallery-slice--next-no-labels'),
            prevEl: el.querySelector('.cms-content-gallery-slice--prev-no-labels'),
        },
        breakpoints: {
            576: {
                loop: true,
            }
        },
    });
}

function initializeLabelSlider(container, mainSwiper) {
    const labelSwiperEl = container.querySelector('.cms-content-gallery-slice__swiper');
    if (!labelSwiperEl) return null;

    const labelItems = Array.from(labelSwiperEl.querySelectorAll('.cms-content-gallery-slice__pagination-labels--label'));

    const labelSwiper = new Swiper(labelSwiperEl, {
        modules: [Navigation],
        speed: 400,
        spaceBetween: 10,
        navigation: {
            nextEl: '.next-button-labels',
            prevEl: '.prev-button-labels',
        },
        breakpoints: {
            768: {
                slidesPerView: "auto",
                spaceBetween: 10,
            },
            576: {
                slidesPerView: 1,
                spaceBetween: 0,
            }
        },
        on: {
            slideChange: () => updateNavigationArrows(labelSwiper),
            click: () => handleLabelClick(labelSwiper)
        }
    });

    setActiveLabel(mainSwiper.realIndex, labelItems);

    function handleLabelClick(swiper) {
        const clickedIndex = swiper.clickedIndex;
        if (typeof clickedIndex !== 'undefined') {
            mainSwiper.slideToLoop(clickedIndex);
        }
    }

    function setActiveLabel(activeIndex, labels) {
        labels.forEach((label, index) => {
            label.classList.toggle('cms-content-gallery-slice__pagination-labels--label--active', index === activeIndex);
        });
    }

    function updateNavigationArrows(swiper) {
        const prevArrow = container.querySelector('.prev-button-labels');
        const nextArrow = container.querySelector('.next-button-labels');
        setArrowState(prevArrow, swiper.isBeginning);
        setArrowState(nextArrow, swiper.isEnd);
    }

    function setArrowState(arrow, isDisabled) {
        const circle = arrow.querySelector('svg circle');
        arrow.classList.toggle('cms-content-gallery-slice__disabled', isDisabled);
        circle.setAttribute('fill', isDisabled ? '#d8d8d8' : '#0B1E3A');
    }

    function slideToNextItem() {
        const containerRect = labelSwiperEl.getBoundingClientRect();
        const lastLabelIndex = labelItems.length - 1;
        const lastLabelRect = labelItems[lastLabelIndex].getBoundingClientRect();
        // Check if the last label is partially visible
        if (lastLabelRect.right > containerRect.right && lastLabelRect.left < containerRect.right) {
            labelSwiper.slideToLoop(lastLabelIndex);
            updateNavigationArrows(labelSwiper)
        } else {
            let shiftAmount = 0;
            for (let i = 0; i <= lastLabelIndex; i++) {
                const labelRect = labelItems[i].getBoundingClientRect();
                if (labelRect.right > containerRect.right) {
                    shiftAmount = Math.ceil(labelRect.right - containerRect.right);
                    break;
                }
            }
            if (shiftAmount > 0) {
                labelSwiper.setTranslate(labelSwiper.translate - shiftAmount);
            }
        }
    }

    const nextButton = container.querySelector('.next-button-labels');

    nextButton.addEventListener('click', () => {
        if (labelSwiper.params.slidesPerView !== 1) {
            slideToNextItem();
        }
    });

    mainSwiper.on('slideChange', () => {
        const realIndex = mainSwiper.realIndex;
        setActiveLabel(realIndex, labelItems);
        labelSwiper.slideToLoop(realIndex);
    });

    labelSwiper.on('slideChange', () => {
        if (labelSwiper.params.slidesPerView === 1) {
            const realIndex = labelSwiper.realIndex;
            mainSwiper.slideToLoop(realIndex);
        }
    });

    return labelSwiper;
}


// WEBPACK FOOTER //
// ./resources/assets/js/cms-content-slices/modules/content-gallery-slice.js